/**
 * 新增 or 编辑
 */
import {useEffect, useRef, useState} from 'react';
import {Button, message} from 'antd';
import {SActionBtn, SFuncModal, SFuncModalFormRef, SLowcodeList, STableActions} from 'shj-components';
import {channelMarkSave, channelMarkUpdateById, getChannelMarkListByChannelId} from '@/services/channelManagement'
import {ModalAddOrEditDom} from './addOrEdit';
import config from './config'

interface IProps {
  data: {
    id: string | number,
    markType: string
  };
  fn: (data?: any[]) => void;
  tableData: any[] | undefined
}

export const ModalTableDom = (props: IProps) => {
  const editRef = useRef<SFuncModalFormRef>({onReset: undefined, onFinish: undefined});
  const {data: {id, markType}} = props;
  const tableRef = useRef<any>();
  const [channelMarkList, setChannelMarkList] = useState<any>(props?.tableData || []); // 渠道标记列表

  // 初始化
  const fetchList = () => {
    return new Promise((resolve) => {
      if (!markType) {
        getChannelMarkListByChannelId(id).then((list) => {
          resolve({records: list})
        });
      } else {
        resolve({records: channelMarkList});
      }
    });
  };

  useEffect(() => {
    tableRef.current.updateDataSource([...channelMarkList]);
    props.fn && props.fn(channelMarkList);
  }, [channelMarkList]);

  useEffect(() => {
    tableRef.current.updateDataSource([...(props?.tableData || [])]);
  }, [props?.tableData]);

  const changeDataEnableFlag = async (val: any, record: any) => {
    const newValues = {...record, channelId: id, enableFlag: val ? 1 : 0};
    if (!markType) {
      if (newValues.id) {
        await channelMarkUpdateById({data: newValues});
      } else {
        await channelMarkSave({data: newValues});
      }
      message.success(`${val ? '启用' : '停用'}成功`);
      tableRef.current.reload();
    } else {
      updateIndexTableList(newValues, record);
    }
  };
  // 跟进索引-更新数据
  const updateIndexTableList = (newValues: any, record: any) => {
    const index = tableRef.current
      .getDataSource()
      .map((item: any) => item.markCode)
      .indexOf(record.markCode);
    const list_ = [...tableRef.current.getDataSource()];
    const {enableFlag, markCode, markName} = newValues;
    list_[index] = {enableFlag, markCode, markName};
    setChannelMarkList(list_);
  };

  const onAddOrEditModal = (query: Record<string, any> = {}) => {
    SFuncModal({
      formRef: editRef.current,
      // cancel: false,
      // reset: true,
      title: `${query.record ? '编辑' : '新增'}`,
      content: <ModalAddOrEditDom editRef={editRef} {...query}/>
    });
  }

  const onAdd = () => {
    let fn;
    if (!markType) {
      fn = () => tableRef.current.reload()
    } else {
      fn = (newValues: any) => {
        const list = [...channelMarkList];
        const {enableFlag, markCode, markName} = newValues;
        const isRepeat = list.some((item) => item.markCode === newValues.markCode);
        if (isRepeat) return message.error('标记编码不能重复！');
        list.push({enableFlag, markCode, markName});
        setChannelMarkList(list);
      }
    }

    onAddOrEditModal({
      fn,
      channelId: id,
      markType: !markType ? '' : 'addMark',
    })

  };

  const onEdit = (record: Record<string, any>) => {
    let fn;
    if (!markType) {
      fn = () => tableRef.current.reload()
    } else {
      fn = (newValues: any) => {
        const list = [...channelMarkList];
        const isRepeat = list.some((item) => item.markCode === newValues.markCode);
        if (isRepeat) return message.error('标记编码不能重复！');
        updateIndexTableList(newValues, record)
      }
    }

    onAddOrEditModal({
      fn,
      record,
      markType: !markType ? '' : 'editMark',
    });
  };

  const extension = {
    searchMode:"group",
    request: {fetchList},
    events: {onAdd},
    customRender: {
      enableRender: (v: string) => v ? '启用' : '停用',
      actionRender: (_: undefined, record: Record<string, any>) => {
        return <STableActions>
          <SActionBtn
            onClick={() => onEdit(record)}
          >
            编辑
          </SActionBtn>
          <SActionBtn
            confirm
            title={`是否${!record.enableFlag ? '启用' : '停用'}?`}
            onClick={() => changeDataEnableFlag(!record.enableFlag, record)}>{!record.enableFlag ? '启用' : '停用'}</SActionBtn>
        </STableActions>
      }
    }
  };

  return (
    <div>
      <Button onClick={onAdd} type='primary' style={{marginBottom:'6px'}}>新增</Button>
      <SLowcodeList config={config} {...extension} ref={tableRef}/>
    </div>
  );
};
